(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flipping-card"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dialog-component')) {
    class DialogComponent extends HTMLElement {
      constructor() {
        super();
        this.dialogButton = null;
        this.dialogModal = null;
        this.closeButton = null;
        this.resizeHandler = null;
        this.animationDuration = null;
      }

      connectedCallback() {
        this.dialogButton = this.querySelector('[data-ref="popup-toggle"]');
        this.dialogModal = this.querySelector('[data-ref="popup-modal"]');
        this.closeButton = this.querySelector('[data-ref="popup-close"]');

        this.animationDuration = 0.3;

        if (!this.dialogModal) return;

        if (this.dialogButton) {
          this.dialogButton.addEventListener('click', this.#showModal.bind(this));
        }

        this.closeButton.addEventListener('click', this.#closeModal.bind(this));
        this.dialogModal.addEventListener('close', this.#onClose.bind(this));
        this.dialogModal.addEventListener('click', this.#onBackdropClick.bind(this));

        this.resizeHandler = this.#onResize.bind(this);
        window.addEventListener('resize', this.resizeHandler);
      }

      disconnectedCallback() {
        if (this.dialogButton) {
          this.dialogButton.removeEventListener('click', this.#showModal.bind(this));
        }

        if (this.dialogModal) {
          this.dialogModal.removeEventListener('close', this.#onClose.bind(this));
          this.dialogModal.removeEventListener('click', this.#onBackdropClick.bind(this));
        }

        if (this.closeButton) {
          this.closeButton.removeEventListener('click', this.#closeModal.bind(this));
        }

        if (this.resizeHandler) {
          window.removeEventListener('resize', this.resizeHandler);
        }
      }

      #showModal(event) {
        if (event) event.preventDefault();
        this.dialogModal.showModal();
        this.dialogModal.scrollTop = 0;
        document.body.classList.add('overflow-hidden');
      }

      #closeModal(event) {
        if (event) event.preventDefault();
        this.#animateClose();
      }

      #animateClose() {
        if (!this.dialogModal || !this.dialogModal.open) return;

        this.dialogModal.classList.add('dialog-modal--closing');

        const handleAnimationEnd = () => {
          this.dialogModal.classList.remove('dialog-modal--closing');
          this.dialogModal.removeEventListener('animationend', handleAnimationEnd);
          this.dialogModal.close();
        };

        this.dialogModal.addEventListener('animationend', handleAnimationEnd);

        setTimeout(() => {
          if (this.dialogModal.classList.contains('dialog-modal--closing')) {
            handleAnimationEnd();
          }
        }, this.animationDuration * 1000);
      }

      #onClose() {
        document.body.classList.remove('overflow-hidden');
      }

      #onBackdropClick(event) {
        const rect = this.dialogModal.getBoundingClientRect();
        const isInDialog =
          rect.top <= event.clientY &&
          event.clientY <= rect.top + rect.height &&
          rect.left <= event.clientX &&
          event.clientX <= rect.left + rect.width;

        if (!isInDialog) {
          this.#animateClose();
        }
      }

      #onResize() {
        if (this.isOpen) {
          this.#animateClose();
        }
      }

      open() {
        this.#showModal();
      }

      close() {
        if (this.dialogModal && this.dialogModal.open) {
          this.#animateClose();
        }
      }

      get isOpen() {
        return this.dialogModal ? this.dialogModal.open : false;
      }
    }

    customElements.define('dialog-component', DialogComponent);
  }

  } catch(e) { console.error(e); }
})();
})();
